<template>
  <div
    :class="{ unLockLogin: state.isShowLogin }"
    class="lockscreen"
    @keyup="unLockLogin(true)"
    @mousedown.stop
    @contextmenu.prevent
  >
    <template v-if="!state.isShowLogin">
      <div class="lock-box" @click="unLockLogin(true)">
        <div class="flex justify-center cursor-pointer">
          <icon-local-lock></icon-local-lock>
        </div>

        <h6 class="tips">{{ $t('header.lockScreen') }}</h6>
      </div>
      <!-- 小米 / 华为 充电-->
      <XiaomiCharge :level="level"></XiaomiCharge>
    </template>
    <template v-if="!state.isShowLogin">
      <div class="local-time">
        <div class="time">{{ hour }}:{{ minute }}</div>
        <div class="date">{{ month }} / {{ day }}，星期{{ week }}</div>
      </div>
      <div class="computer-status flex">
        <icon-local-wifi />
        <icon-local-api-outlined />
      </div>
    </template>
    <template v-if="state.isShowLogin">
      <div class="login-box">
        <icon-local-avatar class="text-130px" />
        <div class="username">{{ state.loginForm.username }}</div>
        <n-input-group>
          <n-input
            v-model:value="state.loginForm.password"
            type="password"
            autofocus
            clearable
            placeholder="请输入登录密码"
            @keyup.enter="onLogin"
          />
          <div class="icon bg-primary" @click="onLogin">
            <svg
              focusable="false"
              class=""
              data-icon="arrow-right"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              viewBox="64 64 896 896"
            >
              <path
                d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"
              ></path>
            </svg>
          </div>
        </n-input-group>

        <a class="mt-10px text-primary cursor-pointer" @click="authStore.resetAuthStore">
          {{ $t('header.restLogin') }}
        </a>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import { useBattery } from '@vueuse/core';
import { useAuthStore, useLockscreenStore } from '@/store';
import { useTime } from '@/hooks';
import { md5 } from '@/utils/crypto';
import { t } from '@/locales';
import XiaomiCharge from './xiaomi-charge.vue';
const { level } = useBattery();

const lockscreenStore = useLockscreenStore();
const authStore = useAuthStore();
// 获取本地时间
const { month, day, hour, minute, week } = useTime();

defineOptions({
  name: 'LockScreen'
});

const state = reactive({
  isShowLogin: false,
  loginLoading: false, // 正在登录
  loginForm: {
    username: authStore.userInfo.username,
    password: ''
  }
});

// 解锁登录
const unLockLogin = (val: boolean) => (state.isShowLogin = val);
// 登录
const onLogin = async () => {
  if (state.loginForm.password.trim() === '') {
    return window.$message?.warning(t('validate.password'));
  }
  const params = { ...state.loginForm };
  state.loginLoading = true;
  const password = md5(params.password + authStore.userInfo.salt);
  if (password === authStore.userInfo.password) {
    unLockLogin(false);
    lockscreenStore.setLock(false);
  } else {
    window.$message?.warning(t('common.loginError'));
  }
  state.loginLoading = false;
};
</script>

<style scoped>
.lockscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  overflow: hidden;
  color: white;
  background-color: #000;
}

.unLockLogin {
  background-color: rgba(25, 28, 34, 0.78);
  backdrop-filter: blur(7px);
}

.lockscreen .login-box {
  position: absolute;
  top: 45%;
  left: 50%;
  display: flex;
  transform: translate(-50%, -50%);
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.lockscreen .login-box > * {
  margin-bottom: 14px;
}

.lockscreen .login-box .username {
  font-size: 30px;
}

.lockscreen .lock-box {
  position: absolute;
  top: 12vh;
  left: 50%;
  font-size: 28px;
  transform: translateX(-50%);
}

.lockscreen .lock-box .tips {
  color: white;
  cursor: pointer;
}

.lockscreen .lock-box .lock {
  display: flex;
  justify-content: center;
}

.lockscreen .lock-box .lock .lock-icon {
  cursor: pointer;
}

.lockscreen .lock-box .lock .lock-icon .anticon-unlock {
  display: none;
}

.lockscreen .lock-box .lock .lock-icon:hover .anticon-unlock {
  display: initial;
}

.lockscreen .lock-box .lock .lock-icon:hover .anticon-lock {
  display: none;
}

.lockscreen .local-time {
  position: absolute;
  bottom: 60px;
  left: 60px;
  font-family: helvetica;
}

.lockscreen .local-time .time {
  font-size: 70px;
}

.lockscreen .local-time .date {
  font-size: 40px;
}

.lockscreen .computer-status {
  position: absolute;
  right: 60px;
  bottom: 60px;
  font-size: 24px;
}

.lockscreen .computer-status > * {
  margin-left: 14px;
}

.lockscreen .computer-status .network {
  position: relative;
}

.lockscreen .computer-status .network.offline::before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  width: 2px;
  height: 28px;
  background-color: red;
  content: '';
  transform: translate(-50%, -50%) rotate(45deg);
}

.icon {
  width: 48px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
